/**
 * 按钮效果指令
 * @description 为按钮添加点击波纹效果和悬停效果
 */
export default {
  bind(el, binding) {
    el.addEventListener('click', e => {
      const rect = el.getBoundingClientRect()
      const ripple = document.createElement('span')
      ripple.className = 'ripple'
      ripple.style.height = ripple.style.width = Math.max(rect.width, rect.height) + 'px'
      el.appendChild(ripple)
      ripple.style.left = e.clientX - rect.left - ripple.offsetWidth / 2 + 'px'
      ripple.style.top = e.clientY - rect.top - ripple.offsetHeight / 2 + 'px'
      ripple.style.animationDuration = Math.sqrt(ripple.offsetWidth * ripple.offsetHeight) * 2 + 'ms'
      ripple.addEventListener('animationend', () => {
        ripple.remove()
      })
    })

    el.addEventListener('mouseenter', () => {
      el.classList.add('button-hover')
    })

    el.addEventListener('mouseleave', () => {
      el.classList.remove('button-hover')
    })
  }
}